import { sanitizeUrl } from '@sp/util/links';
import { LinkAttachment } from '@sp/util/stream-chat';
import { ReactElement, useMemo } from 'react';

export function EditorAttachmentLinkView({ attachment }: { attachment: LinkAttachment }): ReactElement | null {
  const sanitizedUrl = useMemo(() => sanitizeUrl(attachment.url), [attachment.url]);

  let host: string | null = null;

  try {
    host = new URL(sanitizedUrl).host;
  } catch (e) {
    console.error('original:', attachment.url, 'sanitized:', sanitizedUrl, e);
  }

  if (host == null) {
    return null;
  }

  return (
    <a
      className="w-full no-underline hover:underline text-xs p-3 h-16 overflow-hidden rounded-1.5lg bg-secondary border-stroke border block"
      href={sanitizedUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <header className="flex items-center gap-2">
        {attachment.previewUrl ? (
          <img src={attachment.previewUrl} alt={attachment.name} className="w-4 h-4 overflow-hidden" />
        ) : (
          <div className="w-4 h-4 bg-brand-main rounded-lg" />
        )}
        <div className="text-secondary text-ellipsis">{host}</div>
      </header>
      <div className="font-semibold text-ellipsis overflow-hidden whitespace-nowrap">{attachment.name}</div>
    </a>
  );
}
